
<span
    v-if="template"
    class="icon"
    :data-name="icon"
    v-html="template"
/>
